import { useCallback } from 'react';
import { useDebouncedCallback } from './useDebouncedCallback.js';

var useDelayedRedirect = function (navigate, delay) {
    var redirect = useCallback(function (path, options) {
        navigate(path, options);
    }, [navigate]);
    var debouncedRedirect = useDebouncedCallback(redirect, delay);
    // If the delay is 0 or less, return the redirect function directly
    return delay <= 0 ? redirect : debouncedRedirect;
};

export { useDelayedRedirect };
//# sourceMappingURL=useDelayedRedirect.js.map
